export default class reportesService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/reportes',
			"id": '/api/reportes/:codigo',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getByCode(data){
		let idRoute = this.routes.id.replace(':codigo', data.codigo);
		let url = this.baseUrl + idRoute + '?token=' + localStorage.getItem('token');
		window.open(url);
		// return this.http.get(url);
	}

}



// WEBPACK FOOTER //
// ./app/js/services/reportesService.js